export default __webpack_public_path__ + "static/media/13.8c60319e.jpg";